export enum InsulationPropertyName {
  material = 'material',
  form = 'form',
  density = 'density',
  conductivity = 'conductivity',
}

export enum InsulationSpecialPropertyName {
  SoundBatts = 'sound_batts',
}

export enum InsulationMaterial {
  CelluloseFibre = 'Cellulose fibre',
  HempFibre = 'Hemp fibre',
  Hempcrete = 'Hempcrete',
  GlassWool = 'Mineral wool, glass',
  StoneWool = 'Mineral wool, stone',
  Phenolic = 'Phenolic',
  WoodFibre = 'WoodFibre',
  EPS = 'EPS',
  XPS = 'XPS',
}

export enum CelluloseFibre {
  Batts = 'Batts, paper',
  BlowingWoolPostConsumerPaper = 'Blowing, paper, recycled',
  BlowingWoolPrimaryRawMaterial = 'Blowing, primary',
  BlowingWoolRecycledPrimaryPaper = 'Blowing, paper',
}

export enum HempFibre {
  Polyester = '8% polyester or polyolefin binders',
  Polylactic = '8% polylactic acid (PLA) binder',
}

export enum WoodFibre {
  Batts = 'Batts',
  BlowingWool = 'Blowing wool',
}

export enum Wool {
  BattsAndRolls = 'Batts & Rolls',
  BlowingWoolAtticFloor = 'Blowing, attic',
  BlowingWoolFlooring = 'Blowing, floor',
  BlowingWoolWall = 'Blowing, wall',
  FacadeBoard = 'Boards, facade',
}

export enum GlassWoolBattsAndRolls {
  General = 'General',
  SoundBatts = 'Sound batts',
}

export enum StoneWool {
  GroundBoard = 'Boards, ground',
  PlasterBoard = 'Boards, plaster',
  RoofBoard = 'Boards, roof',
}

export enum InsulationProducts {
  CelluloseFibreBatts = 'boverket_sv-SE_6000000173',
  CelluloseFibreBlowingWoolPostConsumerPaper = 'boverket_sv-SE_6000000138',
  CelluloseFibreBlowingWoolPrimaryRawMaterial = 'boverket_sv-SE_6000000134',
  CelluloseFibreBlowingWoolRecycledPrimaryPaper = 'boverket_sv-SE_6000000137',
  HempFibrePolyester = 'boverket_sv-SE_6000000202',
  HempFibrePolylactic = 'boverket_sv-SE_6000000201',
  Hempcrete = 'boverket_sv-SE_6000000208',
  GlassWoolBattsAndRollsSoundBatts = 'boverket_sv-SE_6000000006',
  GlassWoolBattsAndRollsGeneral = 'boverket_sv-SE_6000000001',
  GlassWoolBlowingWoolAtticFloor = 'boverket_sv-SE_6000000005',
  GlassWoolBlowingWoolFlooring = 'boverket_sv-SE_6000000004',
  GlassWoolBlowingWoolWall = 'boverket_sv-SE_6000000003',
  GlassWoolFacadeBoard = 'boverket_sv-SE_6000000002',
  StoneWoolBattsAndRolls = 'boverket_sv-SE_6000000123',
  StoneWoolBlowingWoolAtticFloor = 'boverket_sv-SE_6000000128',
  StoneWoolBlowingWoolFlooring = 'boverket_sv-SE_6000000129',
  StoneWoolBlowingWoolWall = 'boverket_sv-SE_6000000130',
  StoneWoolFacadeBoard = 'boverket_sv-SE_6000000125',
  StoneWoolGroundBoard = 'boverket_sv-SE_6000000126',
  StoneWoolPlasterBoard = 'boverket_sv-SE_6000000124',
  StoneWoolRoofBoard = 'boverket_sv-SE_6000000127',
  Phenolic = 'boverket_sv-SE_6000000133',
  WoodFibreBatts = 'boverket_sv-SE_6000000136',
  WoodFibreBlowingWool = 'boverket_sv-SE_6000000135',
  EPS = 'boverket_sv-SE_6000000131',
  XPS = 'boverket_sv-SE_6000000132',
}
